/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import clsx from 'clsx';
import { useFormLocked } from 'components/ui/FormLock';
import styles from './Button.module.scss';

export interface IButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  loading?: boolean;
  block?: boolean;
  /** Stay clickable on a locked step, such as Back. */
  lockExempt?: boolean;
}

export default function Button({
  variant = 'primary',
  loading = false,
  block = false,
  disabled,
  className,
  children,
  type = 'button',
  lockExempt = false,
  ...rest
}: IButtonProps) {
  const locked = useFormLocked();
  const isDisabled = disabled || loading || (locked && !lockExempt);

  return (
    <button
      // eslint-disable-next-line react/button-has-type
      type={type}
      className={clsx(
        styles.button,
        styles[variant],
        block && styles.block,
        loading && styles.loading,
        className,
      )}
      disabled={isDisabled}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <span className={styles.spinner} aria-hidden /> : null}
      <span className={styles.label}>{children}</span>
    </button>
  );
}
